<div class="contacts-page">
  <header class="contacts-header">
    <div>
      <h2 class="contacts-title">{{ 'contacts.ajout.title' | translate }}</h2>
      <p class="contacts-subtitle">{{ 'contacts.ajout.subtitle' | translate }}</p>
    </div>
  </header>

  <form class="contacts-form" (ngSubmit)="submit()" [formGroup]="form">
    <label>
      {{ 'contacts.ajout.civilite' | translate }}
      <span class="contacts-optional">{{ 'common.optional' | translate }}</span>
      <select formControlName="civilite" autocomplete="honorific-prefix">
        <option value="">{{ 'common.dash' | translate }}</option>
        @for (civilite of civilites; track civilite) {
          <option [value]="civilite">
            {{ civilite | i18nValue: 'ref.civilite' }}
          </option>
        }
      </select>
    </label>

    <div class="contacts-form-row">
      <label>
        {{ 'contacts.ajout.nom' | translate }}
        <input type="text" formControlName="nom" autocomplete="family-name" />
      </label>
      <label>
        {{ 'contacts.ajout.prenom' | translate }}
        <input type="text" formControlName="prenom" autocomplete="given-name" />
      </label>
    </div>

    <div class="contacts-form-row">
      <label>
        <span class="contacts-label-line">
          {{ 'contacts.ajout.telephoneInitial' | translate }}
          <span class="contacts-optional">{{ 'common.optional' | translate }}</span>
          <app-help-tip textKey="contacts.ajout.telephoneHint" />
        </span>
        <input type="tel" formControlName="telephone" autocomplete="tel" />
      </label>
      <label>
        {{ 'contacts.ajout.email' | translate }}
        <span class="contacts-optional">{{ 'common.optional' | translate }}</span>
        <input type="email" formControlName="mail" autocomplete="email" />
      </label>
    </div>

    <label>
      {{ 'contacts.ajout.notes' | translate }}
      <span class="contacts-optional">{{ 'common.optional' | translate }}</span>
      <textarea rows="4" formControlName="notes"></textarea>
    </label>

    @if (error) {
      <p class="contacts-status contacts-status--error">
        {{ 'contacts.ajout.saveError' | translate }}
      </p>
    }

    <div class="contacts-form-actions">
      <a [routerLink]="routes.contacts" class="contacts-cancel">{{
        'common.cancel' | translate
      }}</a>
      <button type="submit" class="contacts-action-btn" [disabled]="saving">
        {{
        saving
        ? ('common.saving' | translate)
        : ('common.save' | translate)
        }}
      </button>
    </div>
  </form>
</div>
